import DBTasks from '../db/DbTasks';
import { SET_SHOWN_DAY, SELECT_APPOINTMENT_BY_ID, SAVE_TV_PROPERTY_VALUE, SAVE_TV_DATA, SET_TV_PROPERTY_VALUE, SAVE_PERSONS, SELECT_PERSON_BY_ID,
  DELETE_PERSONS, SELECT_NEXT_PERSON_ID, FOTO_ADD, FOTO_REMOVE, SELECT_BOCK_BY_ID, SET_BOCK_VALUE, ADD_BOCK_TO_DB, SAVE_TV_DATA_BOCK,
  DELETE_BOCK_FROM_DB, SELECT_CURRENT_COMPANY, DRIVERS_LIST } from './types';

export const SetShownDay = (val) => dispatch => {
  dispatch({
    type: SET_SHOWN_DAY,
    payload: val
  });
}

export const SelectAppointmentByID = (UniqueID) => dispatch => {
  dispatch({
    type: SELECT_APPOINTMENT_BY_ID,
    UniqueID: UniqueID
  })
}

export const CurrentCompanyID = (IdFirma) => dispatch => {
  dispatch({
    type: SELECT_CURRENT_COMPANY,
    IdFirma: IdFirma
  })
}

export const SelectPersonByID = (ID) => dispatch => {
  dispatch({
    type: SELECT_PERSON_BY_ID,
    Id: ID
  })
}

export const GetNextPersonId = (ID) => dispatch => {
  dispatch({
    type: SELECT_NEXT_PERSON_ID,
    Id: ID
  })
}

export const SavePropertyValue = (app, prop, value) => async (dispatch) => {
  console.log("Save property value ");
  const s = await (new DBTasks()).SavePropertyValue(app, prop, value);
  dispatch({
    type: SAVE_TV_PROPERTY_VALUE,
    app: app,
    prop: prop,
    enteredData: s
  });
}

export const AddBockToDatabase = (bockObj) => async (dispatch) => {
  const s = await (new DBTasks()).SaveAddedBock(bockObj);
  dispatch({
    type: ADD_BOCK_TO_DB,
    bock: s,
  });
}

export const DeleteDBBocks = (data) => async (dispatch) => {
  console.log(data);
  const s = await (new DBTasks()).deleteDBBocks(data);
  dispatch({
      type: DELETE_BOCK_FROM_DB,
      idToDelete: s
  });
}

export const SaveData = (app, data) => async (dispatch) => {
  const s = await (new DBTasks()).SaveData(app, data);
  dispatch({
      type: SAVE_TV_DATA,
      app: app,
      enteredData: s
  });
}

export const SaveDataBock = (data) => async (dispatch) => {
  const s = await (new DBTasks()).SaveDataBock(data);
  dispatch({
      type: SAVE_TV_DATA_BOCK,
      app: s,
  });
}

export const AddPersonToDB = (data) => async (dispatch) => {
  console.log(data);
  const s = await (new DBTasks()).addDBPersons(data);
  dispatch({
      type: SAVE_PERSONS,
      persons: s
  });
}

export const DeleteDBPersons = (data) => async (dispatch) => {
  console.log(data);
  const s = await (new DBTasks()).deleteDBPersons(data);
  dispatch({
      type: DELETE_PERSONS,
      idToDelete: s
  });
}


export const SetPropertyValue = (app, prop, value) => async (dispatch) => {
  dispatch({
      type: SET_TV_PROPERTY_VALUE,
      app:app,
      prop: prop,
      value: value
  });
}

export const SaveSignatures = (app, value) => async (dispatch) => {
  const res = await (new DBTasks()).SaveSignatures(app, value);
  dispatch({
      type: SAVE_TV_DATA,
      app:app,
      enteredData: res
  });
}

export const FotoAdd = (app, data) => async (dispatch) => {
  let res = await (new DBTasks()).FotoAdd(app, data);
  dispatch({
      type: FOTO_ADD,
      payload: res
  });
}

export const FotoRemove = (id) => async (dispatch) => {
  await (new DBTasks()).FotoRemove(id);
  dispatch({
      type: FOTO_REMOVE,
      payload: id
  });
}

export const SelectBockByID = (UniqueID) => dispatch => {
  dispatch({
    type: SELECT_BOCK_BY_ID,
    UniqueID: UniqueID
  })
}

export const SetBockValue = (app, prop, value) => async (dispatch) => {
  dispatch({
      type: SET_BOCK_VALUE,
      app:app,
      prop: prop,
      value: value
  });
}

export const GetListOfDrivers = (id) => async (dispatch) => {
  let res = await (new DBTasks()).getListOfDrivers(id);
  dispatch({
      type: DRIVERS_LIST,
      payload: res
  });
}


